import type { FunctionComponent } from 'react';
import { CardGroup } from '@george-labs.com/design-system';

import { isAlexProxyActive } from '@shared/environment';

import { DevToolsCard } from '../DevToolsCard';
import { RecordToggle } from './RecordToggle';
import { SessionDetailsLink } from './SessionDetailsLink';
import { SessionLinkCopyButton } from './SessionLinkCopyButton';
import { ProxyVersionToggle } from './ProxyVersionToggle';
import { getProxyCardTitle, isReplayingAlexProxySession } from './ProxyCardService';

export const ProxyCard: FunctionComponent = () => {
    return (
        <CardGroup noGap className="mt-0 rounded-0">
            <DevToolsCard title={getProxyCardTitle()}>
                <ProxyVersionToggle />
                {!isReplayingAlexProxySession() && <RecordToggle />}
                {isAlexProxyActive() && <SessionDetailsLink />}
                {isReplayingAlexProxySession() && <SessionLinkCopyButton />}
            </DevToolsCard>
        </CardGroup>
    );
};
